import VoucherDetailInertiaController from '@/actions/App/Http/Controllers/VoucherDetailInertiaController';
import { SectionRail } from '@/components/common/section-rail';
import { VoucherCard, type VoucherCardVoucher } from '@/components/common/voucher-card';

interface FeaturedVouchersSectionProps {
  vouchers?: VoucherCardVoucher[];
  className?: string;
}

const FeaturedVouchersSection = ({ vouchers, className }: FeaturedVouchersSectionProps) => {
  const items = vouchers ?? [];
  if (items.length === 0) return null;

  return (
    <SectionRail
      title="Ưu đãi nổi bật"
      subtitle="Mã giảm giá đang áp dụng"
      itemClassName="w-[260px] md:w-[300px]"
      className={className}
    >
      {items.map((voucher, index) => (
        <VoucherCard
          key={voucher.id}
          voucher={voucher}
          href={VoucherDetailInertiaController.show(voucher.code).url}
          featured={index === 0}
          className="aspect-[3/2]"
        />
      ))}
    </SectionRail>
  );
};

export { FeaturedVouchersSection };
